import { DELIVERY_WORKING_TIME_END, DELIVERY_WORKING_TIME_START } from "@/app/order/use-delivery-form";
import { Card } from "../card/card";

import styles from "../poster.module.css";

export const InfoColumn = () => (
  <div className={styles.right}>
    <h2 className={styles.title}>Время работы:</h2>
    <Card
      title={"ПТ-ВС"}
      text={`${DELIVERY_WORKING_TIME_START}:00-${DELIVERY_WORKING_TIME_END}:00`}
      type={"default"}
      className={styles.timeCard}
    />
    <Card
      title={"Телефон:"}
      text={"33-31-00"}
      type={"primary"}
      className={styles.timeCard}
    />
  </div>
);
